import React from 'react';
import { Button } from 'reactstrap';
import Spinner from '~/components/spinner/spinner';
import styles from './styles.css';

const SubmissionButton = ({ isSubmitting, children, ...props }) => {
  return (
    <Button type="submit" {...props} disabled={isSubmitting}>
      {isSubmitting ? <Spinner className={`stroke-white ${styles.spinner}`} /> : children}
    </Button>
  );
};

export default SubmissionButton;



// WEBPACK FOOTER //
// ./src/components/submissionButton/submissionButton.jsx